import { Channel } from './channel';
import { Quadrant } from './quadrant';
import { Result } from './resultGroups';
import { ResultMapper } from './result-mapper';
import { ResultMapperMetricsMerged } from './result-mapper-metrics';
import { ResultMapperRead } from './result-read';
import { ResultPangolianMapper } from './ResultPangolianMapper';
export class CovidSamples {
    barcode : string;
    positionRow : number;
    prositionCol : number;
    cpValue : number;
    result : string;
    originalResult: string;
    inValidResult : boolean;
    comments : string;
    quadrant: Quadrant;
    contaminationType: string;
    twoSwabsComment: string;
    defaultContaminationComment: string;
    boxId: string;
    receivedBatchID: string;
    channels: Channel[];
    results: Result[] = [];
    nonConformanceProblem: string;
    documentBarcode:string;
    customersBarcode:string;
    icrChannelUpdateIndex: number;
    icrChannelUpdateResult: boolean;
    unboxedSender: string;
    singleSampleRedo: boolean;
    archiveSlot: number;
    cyclerManufacturer: string;
    extractorManufacturer: string;
    archievePositionRow: number;
    archievePositionCol: number;
    tagPlateId: string;
    u7Sequence: string;
    u5Sequence: string;
    articQC: ResultMapper[];
    libQC: ResultMapper[];
    numberReads: ResultMapperRead[];
    metricsMergedResults: ResultMapperMetricsMerged[];
    mutationInfo: MutationInfo[];
    linageClassification: ResultPangolianMapper[];
    lastImportedDateTimeForMutationAnalysis: Date;
    lastRunForMutationAnalysis: string;
    qcFailedResultWithReason: QCFailedResultWithReason;
    ntcControl: string;
    index: number;
    positionRow96: number;
    positionCol96: number;
    product: string;
    sender: string;
    snpDetailsView: SnpProfileForPlate;
}
export class MachineShortInfo {
    machineName : string;
    machineBarcode : string;
    subType : string;
}

export class MutationInfo{
    mutationAnalysis: MutationCoverage[];
    mutationInfoImportedDatetime: Date;
    dateFromPath: Date
}

export class MutationCoverage{
    mutation: string;
    frequency: string;
}

export class QCFailedResultWithReason{
    mergeMetricsFailed: boolean;
    reasonMergeMetricsFailed: string;
    mergeMetricLastUpdated: Date;
    numberReadsFailed: boolean;
    reasonNumberReadsFailed: string;
    numberReadsLastUpdated: Date;
    mergeMetricReviewedBy: string;
    numberReadsReviewedBy: string;
}

export class SnpProfileForPlate{
    p1TotalCount: number;
    totalCount: number;
    sexDetermination: string;
}